import { ReWeighMentDefectsModel } from "./defects-info-model"

export class ReweighmentInfoModel{
    boxes: number
    sampleQuantity : number
    samplePieces : number
    reweighmentCount : number
    reweighmentInfo : ReWeighMentModelDto[]
    defectsInfo: ReWeighMentDefectsModel[]
    constructor(boxes:number,sampleQuantity : number, samplePieces:number, reweighmentCount :number, reweighmentInfo : ReWeighMentModelDto[],defectsInfo: ReWeighMentDefectsModel[]){
        this.boxes = boxes
        this.sampleQuantity =sampleQuantity
        this.reweighmentInfo = reweighmentInfo
        this.reweighmentCount =reweighmentCount
        this.samplePieces = samplePieces
        this.defectsInfo = defectsInfo
    }
}


export class ReWeighMentModelDto{
    boxes: number;
    quantity: number;

    constructor(

        boxes:number,
        quantity: number,
        
    ){
this.boxes=boxes,
this.quantity = quantity

    }
}